var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F95146"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.44214 5.2941C9.44214 5.2941 11.1001 5.88513 12.1158 5.61297C13.1315 5.34082 14.2718 4 14.2718 4L16.3423 11.7274C16.3423 11.7274 15.202 13.0682 14.1863 13.3404C13.1706 13.6125 11.5127 13.0215 11.5127 13.0215C11.5127 13.0215 9.85472 12.4305 8.83903 12.7026C7.82525 12.9743 6.6873 14.3106 6.68303 14.3156L7.67028 18H6.635L3.51716 6.36405C3.44569 6.09732 3.60398 5.82315 3.87071 5.75168C4.13745 5.68021 4.41162 5.8385 4.48309 6.10523L4.61249 6.58818C4.61673 6.58321 5.75468 5.24687 6.76848 4.97522C7.78417 4.70307 9.44214 5.2941 9.44214 5.2941Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailBadge);
export default __webpack_public_path__ + "static/media/failBadge.8e860fc98fda5de9bf0a2b9ee2c7431e.svg";
export { ForwardRef as ReactComponent };